import React from 'react';

/**
 * A small down-pointing stroked chevron, used as the expand/collapse affordance on a
 * clickable row (e.g. a picker/accordion header). Pass `style={{ transform: 'rotate(180deg)' }}`
 * to flip it for an "open" state — this is left to the caller rather than an `open` prop so a
 * single icon covers any rotation-driven open/close convention.
 */
const ChevronDown = ({
  width = 10,
  height = 6,
  color = 'currentColor',
  className,
  style,
  ...rest
}) => (
  <svg
    className={className}
    style={style}
    viewBox="0 0 10 6"
    width={width}
    height={height}
    fill="none"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M1 1L5 5L9 1"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDown;
